<template>
  <div>
    <vx-card v-if="board" class="w-full">
      <div class="flex justify-between items-center">
        <h4>종사자 정보</h4>
        <vs-button color="secondary" @click="onClickSave">저장</vs-button>
      </div>
      <p class="mt-6 mb-5">
        ※ 각 부서에서 관리감독자가 담당종사자를 엑셀파일로 대량 등록하는하는 페이지입니다. <br />
        ※ 엑셀 템플릿을 다운받고, 종사자들의 사업장과 부서를 선택하여 선택한 데이터에 해당하는 엑셀파일을 작성하여 업로드합니다.<br />
        ※ 최초 작성 후 변동사항이 생겼을 시 [종사자 등록] 메뉴에서 등록된 문서를 열어 수정하여 저장합니다.
      </p>

      <!-- 기본정보 -->
      <field-select-module v-model="form.stdInfo" :board="board" :types="['department', 'com_name', 'rank', 'writer_name', 'date']" />

      <!-- 종사자 소속 지정 및 엑셀 업로드 -->
      <div>
        <h5 class="mt-6 mb-4"><i class="dot"></i> 종사자 소속 지정 및 엑셀 업로드</h5>
        <div class="writeGridContainer">
          <div class="writeGridLineItem">
            <div>사업장명</div>
            <field-selector :readonly="board.readonly" v-model="form.fields" />
          </div>
          <div>
            <div>부서</div>
            <company-selector v-model="form.company" />
          </div>
          <div class="writeGridLineItem">
            <div>파일 업로드</div>
            <div>
              <vs-button color="secondary" type="border" href="https://bsgs.maot.co.kr:8080/storage/app/media/%EC%A2%85%EC%82%AC%EC%9E%90_%EC%97%85%EB%A1%9C%EB%93%9C_%ED%85%9C%ED%94%8C%EB%A6%BF.xlsx">엑셀 템플릿 다운로드</vs-button>
              <vs-button color="secondary" class="ml-2" @click="onClickExcelUpload"> 작성 엑셀 업로드 </vs-button>
              <input v-show="false" ref="excelInput" type="file" @change="readFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
            </div>
          </div>
        </div>
      </div>

      <!-- 등록 대상 종사자 정보 -->
      <div>
        <div class="flex justify-between items-center mt-6 mb-4">
          <h5><i class="dot"></i> 등록 대상 종사자 정보</h5>
          <vs-button color="secondary" type="border" @click="onClickCheckRemove">선택삭제</vs-button>
        </div>
        <div style="max-height: 1070px; overflow-y: auto">
          <table>
            <colgroup>
              <col width="60" />
              <col width="60" />
            </colgroup>
            <thead>
            <th><vs-checkbox :value="0 < excelData.length && excelData.length === checkList.length" @click.native="checkAll" class="check" /></th>
            <th>No.</th>
            <th>ID(사번)</th>
            <th>생년월일</th>
            <th>구분</th>
            <th>직종</th>
            <th>직급</th>
            <th>성명</th>
            <th>최종 입사일</th>
            <th>현보직일</th>
            <th>연락처</th>
            <th>퇴임일</th>
            <th>수정/삭제</th>
            </thead>
            <tbody>
            <tr v-for="(excel, excel_i) in excelData" :key="`${excel_i}_${excel[0]}`">
              <td><vs-checkbox :vs-value="excel_i" v-model="checkList" class="check" /></td>
              <td v-for="(_num, _num_i) in 11" :key="`${excel_i}_${excel[0]}_${_num_i}`">
                <div v-if="editExcelIndex === excel_i" class="p-1">
                  <DateSelector v-if="_num_i === 2 || _num_i === 6 || _num_i === 7 || _num_i === 9" v-model="editExcelData[_num_i]" class="w-full" />
                  <ml-input v-else v-model="editExcelData[_num_i]" class="w-full" />
                </div>
                <div v-else>
                  <p>{{ excel[_num_i] || "-" }}</p>
                  <p v-if="!!errorMSG[excel_i] && !!errorMSG[excel_i][_num_i]" class="errMsg">{{ errorMSG[excel_i][_num_i] }}</p>
                </div>
              </td>
              <td>
                <div class="flex justify-center gap-3">
                  <fragment v-if="editExcelIndex === excel_i">
                    <button @click="onClickFinshExcelData(excel_i)">
                      <feather-icon icon="CheckIcon" svgClasses="h-5 w-5" />
                    </button>
                    <button @click="onClickCancelExcelData(excel_i)">
                      <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
                    </button>
                  </fragment>
                  <fragment v-else>
                    <button @click="onClickEditExcelData(excel_i)">
                      <feather-icon icon="Edit2Icon" svgClasses="h-5 w-5" />
                    </button>
                    <button @click="onClickRemoveExcelData(excel_i)">
                      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5" />
                    </button>
                  </fragment>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FieldSelector from "@/components/selector/FieldSelectorMultiple";
import CompanySelector from "@/components/selector/CompanySelector";
import DateSelector from "@/components/selector/DateSelector";
import XLSX from "xlsx";
import moment from "moment";
import HttpRequest from "@/util/HttpRequest";

export default {
  components: {
    FieldSelectModule,
    FieldSelector,
    CompanySelector,
    DateSelector,
  },
  props: {
    board: Object,
  },
  data() {
    return {
      // board: {
      //   projectTitle: this.$store.state.project.projectInfo.field_name,
      //   writer: {}, //작성자 정보
      //   readonly: false, // 읽기전용인가
      //   isPrint: false,
      //   viewSaveBtn: true,
      //   viewRemoveBtn: true,
      // },

      form: {
        stdInfo: {},
        fields: [],
        company: null,
      },

      editExcelIndex: null,
      editExcelData: [],
      excelData: [],
      checkList: [],

      errorMSG: [],
    };
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
  },
  created() {
    this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "종사자의견청취" }, { title: "종사자 정보", active: true }]);
  },
  async mounted() {
  },
  methods: {
    onClickExcelUpload() {
      const excelInput = this.$refs.excelInput;
      excelInput.value = null;
      excelInput.click();
    },
    // 엑셀데이터 파싱
    readFile(event) {
      // get File object from input tag
      const file = event.target.files[0];
      const fileName = file.name;

      // declare FileReader, temp result
      const reader = new FileReader();
      let tmpResult = {};

      // if you use "this", don't use "function(e) {...}"
      reader.onload = (e) => {
        let data = e.target.result;
        data = new Uint8Array(data);
        // get excel file
        let excelFile = XLSX.read(data, { type: "array", cellDates: true });

        // get prased object
        excelFile.SheetNames.forEach(function (sheetName) {
          const roa = XLSX.utils.sheet_to_json(excelFile.Sheets[sheetName], { header: 1 });
          if (roa.length) tmpResult[sheetName] = roa;
        });
        let _data = tmpResult.Sheet1.filter((data, data_i) => data_i !== 0 && 0 < data.length);
        _data = _data.map((row) => {
          return row.map((item, item_i) => {
            let _item = item;
            if (item_i === 2 || item_i === 7 || item_i === 8 || item_i === 10) _item = this.setMoment(_item);
            else if (item_i === 9) _item = this.setPhone(_item);
            return _item;
          });
        });
        this.excelData = [...this.excelData, ..._data];
      };
      reader.readAsArrayBuffer(file);
    },
    setMoment(date) {
      let _date = date;
      if (typeof _date === "number") _date = `${_date}`;
      if (typeof _date === "string" && !_date.includes("-")) _date = `${_date.slice(0, 4)}-${_date.slice(4, 6)}-${_date.slice(6, 8)}`;
      return moment(_date).add(1, "days").format("YYYY-MM-DD");
    },
    setPhone(data) {
      let _data = `${data}`;
      if (typeof data === "number" && _data.length === 10 && _data.charAt(0) !== "0") _data = `0${_data}`;
      return _data.replace(/^(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
    },
    onClickEditExcelData(index) {
      this.editExcelData = JSON.parse(JSON.stringify(this.excelData[index]));
      this.editExcelIndex = index;
      this.errorMSG = [];
    },
    onClickFinshExcelData(index) {
      const _data = this.editExcelData.map((item, item_i) => {
        if (item_i === 6 || item_i === 7 || item_i === 9) return !!item.trim() ? moment(item).format("YYYY-MM-DD") : "";
        else return item;
      });
      this.$set(this.excelData, index, _data);
      this.onClickCancelExcelData();
    },
    onClickCancelExcelData(index) {
      this.editExcelData = [];
      this.editExcelIndex = null;
      this.errorMSG = [];
    },
    onClickRemoveExcelData(index) {
      this.excelData.splice(index, 1);
      this.errorMSG = [];
    },
    checkAll() {
      if (0 < this.excelData.length && this.excelData.length === this.checkList.length) this.checkList = [];
      else this.checkList = this.excelData.map((_, i) => i);
    },
    onClickCheckRemove() {
      if (this.checkList.length < 1) return;
      this.excelData = this.excelData.filter((_, i) => !this.checkList.includes(i));
      this.checkList = [];
      this.errorMSG = [];
    },
    onClickSave() {
      // 사업장명이 선택이 안되어 있을때 에러
      if (this.form.fields.length < 1) {
        this.customAlert("사업장을 선택해주세요");
        return;
      }
      // 부서가 선택이 안되어 있을때 에러
      if (!this.form.company) {
        this.customAlert("부서를 선택해주세요");
        return;
      }
      // 엑셀 데이터가 없을때 에러
      if (this.excelData.length < 1) {
        this.customAlert("등록 대상 종사자 정보가 없습니다");
        return;
      }
      // 종사자 정보에서 ID(사번)이 없는 데이터가 존재할때 에러
      const noneCodeData = this.excelData.filter((ed) => !ed[1]);
      if (0 < noneCodeData.length) {
        this.customAlert("ID(사번)이 없는 종사자 정보가 있습니다");
        return;
      }
      // 종사자 정보에서 ID(사번)이 중복되는 데이터가 존재할때 에러
      const codeData = this.excelData.map((ed) => ed[1]);
      const codeSet = new Set(codeData);
      if (codeData.length !== codeSet.size) {
        this.customAlert("ID(사번)이 중복되는 종사자 정보가 있습니다");
        return;
      }

      this.loading(true);

      const employees = this.excelData.map((ed) => {
        const obj = {
          no: ed[0] || null,
          employee_code: `${ed[1]}`,
          date_of_birth: ed[2] || "",
          job_category: ed[3] || "",
          employment_type: ed[4] || "",
          job_title: ed[5] || "",
          full_name: ed[6] || "",
          hire_date: ed[7] || "",
          current_position_date: ed[8] || "",
          contact_number: ed[9] || "",
          retirement_date: ed[10] || "",
        };
        return Object.entries(obj).reduce((acc, [k, v]) => (v ? { ...acc, [k]: v } : acc), {});
      });

      const option = {
        company_id: this.form.company,
        register_at: this.form.stdInfo.date,
        field_ids: this.form.fields.map((field) => field.id),
        employees,
      };

      HttpRequest.post(`/api/v1/employee/${this.projectId}/bulk`, option, true)
        .then((response) => {
          // 초기화
          this.form.fields = [];
          this.form.company = null;
          this.editExcelIndex = null;
          this.editExcelData = [];
          this.excelData = [];
          this.checkList = [];

          this.loading(false);
          this.customAlert("종사자 정보가 등록되었습니다", "종사자 등록");
        })
        .catch(({ response }) => {
          this.loading(false);
          if (typeof response.data === "string") {
            const err = JSON.parse(response.data);
            this.errorMSG = err.map((_e) => {
              const { no, employee_code, date_of_birth, job_category, employment_type, job_title, full_name, hire_date, current_position_date, contact_number, retirement_date } = _e.error;
              return [no, employee_code, date_of_birth, job_category, employment_type, job_title, full_name, hire_date, current_position_date, contact_number, retirement_date];
            });
          } else if (typeof response.data === "object") {
            const errArray = [];
            const err = response.data;
            for (const _t in err) {
              const key = _t.split(".");
              errArray[key[1]] = { ...errArray[key[1]], ...{ [key[2]]: err[_t] } };
            }

            this.errorMSG = errArray.map((_e) => {
              const { no, employee_code, date_of_birth, job_category, employment_type, job_title, full_name, hire_date, current_position_date, contact_number, retirement_date } = _e;
              return [no, employee_code, date_of_birth, job_category, employment_type, job_title, full_name, hire_date, current_position_date, contact_number, retirement_date];
            });
          }
        });
    },
    customAlert(msg, title) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: !!title ? title : "오류가 발생했습니다",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },
    loading(open) {
      const loadingDialog = new CustomEvent("loadingDialog", {
        detail: {
          open,
        },
      });
      window.dispatchEvent(loadingDialog);
    },
  },
};
</script>

<style scoped lang="scss">
table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    text-align: center;
    padding: 0;
  }

  th {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;

    background: #fafafa;
    border-top: 1px solid #cdcdcd;
    border-bottom: 1px solid #cdcdcd;
    padding: 16px 0;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;

    border-bottom: 1px solid #cdcdcd;
    padding: 16px 0;
  }

  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }
  }

  .check {
    justify-content: center !important;
    ::v-deep {
      span {
        margin: 0;
      }
    }
  }
}
.errMsg {
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  color: #ea5455;
  margin-top: 2px;
}
</style>
